/* eslint-disable no-param-reassign */
import Bugsnag from '@bugsnag/js'
import { isPaginationStalled } from '../utils/pagination'

const reportedQueries = new Set()
const safeCursor = cursor => {
  if (cursor === null || cursor === undefined || cursor === '') return null
  return /^-?\d+(\.\d+)?$/.test(String(cursor)) ? cursor : '[redacted]'
}

export const reportPaginationStall = ({
  queryId,
  cursor,
  size,
  filter,
  orderBy,
  isChatChannel,
  conversations,
}) => {
  // Telemetry must never change the outcome of a successful request.
  try {
    if (
      !conversations ||
      !isPaginationStalled(cursor, conversations.pageInfo) ||
      reportedQueries.has(queryId)
    ) {
      return
    }
    reportedQueries.add(queryId)
    const { nodes = [], totalCount, pageInfo = {} } = conversations
    // queryId and filter values can contain customer search text/PII. Keep only
    // known field names and validated channel/folder IDs, never the raw query.
    const filters = {}
    ;['channelId', 'folderId'].forEach(key => {
      const value = filter?.[key]
      if (/^(ch|fol)_\d+$/.test(value)) filters[key] = value
    })
    filters.hasKeywords = !!filter?.keywords
    const metadata = {
      cursor: safeCursor(cursor),
      size,
      filters,
      orderBy: orderBy
        ? {
            field: /^[A-Z_]+$/.test(orderBy.field)
              ? orderBy.field
              : '[redacted]',
            direction: ['ASC', 'DESC'].includes(orderBy.direction)
              ? orderBy.direction
              : '[redacted]',
          }
        : null,
      nodeCount: nodes.length,
      totalCount,
      pageInfo: {
        hasNextPage: !!pageInfo.hasNextPage,
        hasPreviousPage: !!pageInfo.hasPreviousPage,
        startCursor: safeCursor(pageInfo.startCursor),
        endCursor: safeCursor(pageInfo.endCursor),
      },
      isChatChannel,
    }
    Bugsnag.notify(new Error('Conversation pagination stalled'), event => {
      try {
        event.groupingHash = 'conversation-pagination-stalled'
        event.severity = 'warning'
        event.addMetadata('pagination', metadata)
      } catch (e) {
        // A reporter callback failure must not escape either.
      }
    })
  } catch (e) {
    // Ignore SDK and metadata failures.
  }
}
